var map = {
	"./de_Beta Digitis - Gif.gif": "89fb",
	"./en_Beta Digitis - Gif.gif": "1033",
	"./es_Beta Digitis - Gif.gif": "05e3",
	"./fr_Beta Digitis - Gif.gif": "cff6",
	"./nl_Beta Digitis - Gif.gif": "7fb1",
	"./pl_Beta Digitis - Gif.gif": "e02d",
	"./pt_Beta Digitis - Gif.gif": "1afd",
	"./ru_Beta Digitis - Gif.gif": "80ff",
	"./uk_Beta Digitis - Gif.gif": "c5b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7494";